import { css } from '@emotion/react';
import { Box } from '@spark-web/box';
import { Text } from '@spark-web/text';
import { ThemeProvider } from '@spark-web/theme';
import { FC } from 'react';

import { PARTNER_THEME } from '~/constants';
import starIcon from '~/public/icons/commbank/star.svg';
import { MarketplacePartner } from '~/types/marketplace';

type LocalVendorProps = {
  partner?: MarketplacePartner;
};

export const LocalVendor: FC<LocalVendorProps> = ({ partner }) => {
  return (
    <ThemeProvider>
      <Box
        padding="xsmall"
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap="xxsmall"
        css={css({
          background: 'rgba(0, 210, 153, 0.5)',
        })}
      >
        <ThemeProvider theme={partner ? PARTNER_THEME[partner] : 'brighte'}>
          <img src={starIcon} width={14} height={14} alt="" />
          <Text size="small">Local vendor</Text>
        </ThemeProvider>
      </Box>
    </ThemeProvider>
  );
};
